import React, { useState } from "react";
import { Text, View, TextInput, Platform } from "react-native";
import { connect } from "react-redux";
import { updateOrder } from "../actions/order";
import { fetchApi } from "../api";
import { STYLES } from "../assets/styles";
import CustomButton from "./CustomButton";
import CustomIcon from "./CustomIcon";
import CustomModal from "./CustomModal";

function Review({ orderId, prevReview = {}, style = {}, updateOrder }) {
  const [stars, setStars] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [review, setReview] = useState("");

  const onSubmit = () => {
    if (stars > 0 || prevReview.stars > 0) {
      let body = {
        stars: stars,
        review: review,
      };
      fetchApi({
        path: `/orders/${orderId}/review`,
        method: "POST",
        body: body,
      }).then((res) => {
        if (!res.error) {
          setIsVisible(false);
          updateOrder(res);
        }
      });
    }
  };

  return (
    <View style={style}>
      <View style={{ flexDirection: "row" }}>
        {[1, 2, 3, 4, 5].map((_, index) => (
          <CustomIcon
            type="AntDesign"
            name="star"
            style={{
              color:
                index < stars || index < prevReview.stars
                  ? STYLES.colors.darkBlue
                  : "#00000030",
            }}
            onPress={() => {
              if (!prevReview.review) {
                setStars(index + 1);
              }
            }}
            key={index + "st"}
          />
        ))}
      </View>
      {prevReview.review ? (
        <Text style={{ padding: 5, color: "#000000" }}>
          {prevReview.review}
        </Text>
      ) : (
        <Text
          onPress={() => setIsVisible(true)}
          style={{ color: STYLES.colors.darkBlue, padding: 5 }}
        >
          Write a Review
        </Text>
      )}
      <CustomModal
        visible={isVisible}
        onClose={() => setIsVisible(false)}
        closable
        style={{ justifyContent: "center" }}
      >
        <View
          style={{
            flexDirection: "row",
            marginVertical: 20,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {[1, 2, 3, 4, 5].map((_, index) => (
            <CustomIcon
              type="AntDesign"
              name="star"
              style={{
                color:
                  index < stars || index < prevReview.stars
                    ? STYLES.colors.darkBlue
                    : "#00000030",
              }}
              onPress={() => setStars(index + 1)}
              key={index + "st"}
            />
          ))}
        </View>
        <Text style={{ fontSize: STYLES.fontSizes.large, marginVertical: 5 }}>
          Write your review
        </Text>
        <TextInput
          placeholder="type your review here..."
          multiline
          style={[
            {
              borderWidth: 1,
            },
            Platform.OS === "web" ? { outline: 0 } : {},
          ]}
          value={review}
          onChangeText={(value) => setReview(value)}
          numberOfLines={5}
        />
        <CustomButton
          btnStyle={{
            marginVertical: 15,
            backgroundColor: STYLES.colors.purpel,
            alignSelf: "flex-end",
          }}
          textStyle={{ color: "#ffffff" }}
          text="Submit"
          onPress={onSubmit}
        />
      </CustomModal>
    </View>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  updateOrder: (data) => dispatch(updateOrder(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Review);
